/* eslint-disable max-len */
import * as React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

function LocationShape({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 12 16" aria-labelledby={titleId} {...props}>
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M6 16L1.2 9.538c-1.792-2.226-1.554-5.932.557-7.9 2.344-2.184 6.143-2.184 8.486 0 2.11 1.968 2.348 5.674.557 7.9L6 16zM8 5.5a2 2 0 10-4 0 2 2 0 004 0z"
                fill="#000"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default LocationShape;
